import React, { Fragment } from 'react';
import EntityView from '@/se/components/entity/EntityView';
import { ReportDeliveryEmailButton, ReportDeliverySmsButton } from '../../pages/user/admin/NotificationsButton';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

const UserShowView = (props: any) => (
  <Fragment>
    <EntityView {...props} />
    <Box mt={3}>
      <Typography variant="h6">Report Delivery Channels</Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4, marginBottom: 12 }}>
        Controls which channels this user receives reports on. Currently applies to Executive KPI and OR Schedule
        reports.
      </Typography>
      <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <Typography variant="subtitle2" style={{ minWidth: 60 }}>
            Email
          </Typography>
          <ReportDeliveryEmailButton data={props.data} />
        </Box>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <Typography variant="subtitle2" style={{ minWidth: 60 }}>
            SMS
          </Typography>
          <ReportDeliverySmsButton data={props.data} />
        </Box>
      </Box>
    </Box>
  </Fragment>
);

export default UserShowView;
